import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  BigCheckBoxWrap,
  Btns,
  ButtonL,
  Content,
  InputsDiv,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import { Modal } from "../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/slices/authSlice";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";
import { getToken } from "../../components/hooks/authFunc";
import OnlyTitleHeaderLayout from "../../components/layout/OnlyTitleHeaderLayout";
import SlideModal from "../../components/modal/SlideModal";
import { ReactComponent as ArrowRight } from "../../styles/images/ico_arrow_white.svg";
import ViewModal from "../../components/modal/ViewModal";

const EasySignUp = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [openModal, setOpenModal] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [viewMode, setViewMode] = useState(false);
  const [target, setTarget] = useState("");
  const [checkedPw, setCheckedPw] = useState(false);
  const [checkedEmail, setCheckedEmail] = useState(false);
  const [checkedConfirmPw, setCheckedConfirmPw] = useState(false);
  const [email, setEmail] = useState("");
  const [passwords, setPasswords] = useState({
    password: "",
    confirmPassword: "",
  });
  const modalMsg = useSelector((state) => state.auth.modalMsg);
  // const easySignUpSuccess = useSelector(
  //   (state) => state.auth.easySignUpSuccess
  // );

  const [allAgreed, setAllAgreed] = useState(false);

  const [agreements, setAgreements] = useState({
    eulaAge: false,
    eulaTerms: false,
    eulaPrivacy: false,
    eulaMarketing: false,
  });

  useEffect(() => {
    if (agreements.eulaAge && agreements.eulaTerms && agreements.eulaPrivacy) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
    const allChecked = Object.values(agreements).every(
      (value) => value === true
    );
    setAllAgreed(allChecked);
  }, [agreements]);

  const handleAgreementChange = (e) => {
    const { name, checked } = e.target;

    setAgreements((prev) => ({ ...prev, [name]: checked }));
    const allChecked = Object.values({ ...agreements, [name]: checked }).every(
      (value) => value === true
    );
    setAllAgreed(allChecked);
  };

  const handleAllAgreementChange = (e) => {
    const { checked } = e.target;

    setAgreements((prev) =>
      Object.keys(prev).reduce(
        (newAgreements, agreementKey) => ({
          ...newAgreements,
          [agreementKey]: checked,
        }),
        {}
      )
    );

    setAllAgreed(checked);
  };

  useEffect(() => {
    const passwordRegex =
      /^(?=.*[~!@#$%^&*()?])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[~!@#$%^&*()?a-zA-Z0-9]{8,20}$/;
    if (passwordRegex.test(passwords.password)) {
      setCheckedPw(true);
    } else {
      setCheckedPw(false);
    }

    if (
      passwords.password &&
      passwords.password === passwords.confirmPassword
    ) {
      setCheckedConfirmPw(true);
    } else {
      setCheckedConfirmPw(false);
    }
  }, [passwords]);

  useEffect(() => {
    const emailExp = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/;
    if (emailExp.test(email)) {
      setCheckedEmail(true);
    } else {
      setCheckedEmail(false);
    }
  }, [email]);

  const handleEasySignUp = () => {
    const params = {
      email: email,
      password: passwords.password,
      confirmPassword: passwords.confirmPassword,

      //이메일 등록 key 를 받아서 보내줘야함.. 아마도 파라미터로 받지 않을까 추측
      emailKey: searchParams.get("key"),
    };
    console.log(params);
    // dispatch(authActions.fetchReSettingPassword({ params }));
    //성공시 페이지 이동-> navigate("/sign-up/result");
  };

  // useDidMountEffect(() => {
  //   if (easySignUpSuccess) {
  //     navigate('/sign-up/result');
  //   }
  // }, [easySignUpSuccess]);

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);

  return (
    <OnlyTitleHeaderLayout title="뮤포인트 간편가입">
      {openModal && (
        <Modal
          setOpenModal={setOpenModal}
          title="뮤포인트 간편가입"
          callbackFunc={() => {
            return;
          }}
        >
          <div>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</div>
        </Modal>
      )}
      {viewMode && (
        <ViewModal
          title="이용약관"
          setAgreements={setAgreements}
          setViewMode={setViewMode}
          target={target}
        />
      )}
      {openPopUp && (
        <SlideModal
          btnText={"회원가입"}
          setOpenModal={setOpenPopUp}
          closeModalFunc={() => {}}
          callbackFunc={handleEasySignUp}
          btnDisabled={btnDisabled}
          autoClose={false}
        >
          {/* <h3>아래 항목을 확인해 주세요.</h3>
          <p className="smallP">아래 항목을 확인해 주세요.</p> */}
          <p className="">아래 항목을 확인해 주세요.</p>
          <Detail>
            <AgreeWrap>
              <LabelWarp>
                <BigCheckBoxWrap>
                  <input
                    type="checkbox"
                    name="allAgree"
                    id="allAgree"
                    checked={allAgreed}
                    onChange={handleAllAgreementChange}
                  />
                  <label htmlFor="allAgree">모두 동의합니다.</label>
                </BigCheckBoxWrap>
              </LabelWarp>
            </AgreeWrap>
            <AgreeWrap>
              <LabelWarp>
                <BigCheckBoxWrap>
                  <input
                    type="checkbox"
                    name="eulaAge"
                    id="eulaAge"
                    checked={agreements.eulaAge}
                    onChange={handleAgreementChange}
                  />
                  <label htmlFor="eulaAge">
                    만 14세 이상 확인 <span className="col"> [필수]</span>
                  </label>
                </BigCheckBoxWrap>
                {/* <ArrowRight
                  onClick={() => {
                    setTarget("eulaAge");
                    setViewMode(true);
                  }}
                /> */}
              </LabelWarp>
              <LabelWarp>
                <BigCheckBoxWrap>
                  <input
                    type="checkbox"
                    name="eulaTerms"
                    id="eulaTerms"
                    checked={agreements.eulaTerms}
                    onChange={handleAgreementChange}
                  />
                  <label htmlFor="eulaTerms">
                    서비스 이용 약관 동의 <span className="col"> [필수]</span>
                  </label>
                </BigCheckBoxWrap>
                <ArrowRight
                  onClick={() => {
                    setTarget("eulaTerms");
                    setViewMode(true);
                  }}
                />
              </LabelWarp>
              <LabelWarp>
                <BigCheckBoxWrap>
                  <input
                    type="checkbox"
                    name="eulaPrivacy"
                    id="eulaPrivacy"
                    checked={agreements.eulaPrivacy}
                    onChange={handleAgreementChange}
                  />
                  <label htmlFor="eulaPrivacy">
                    개인정보 처리방침 동의 <span className="col"> [필수]</span>
                  </label>
                </BigCheckBoxWrap>
                <ArrowRight
                  onClick={() => {
                    setTarget("eulaPrivacy");
                    setViewMode(true);
                  }}
                />
              </LabelWarp>
              <LabelWarp>
                <BigCheckBoxWrap>
                  <input
                    type="checkbox"
                    name="eulaMarketing"
                    id="eulaMarketing"
                    checked={agreements.eulaMarketing}
                    onChange={handleAgreementChange}
                  />
                  <label htmlFor="eulaMarketing">
                    마케팅 수신 동의 <span className="col"> [선택]</span>
                  </label>
                </BigCheckBoxWrap>
                <ArrowRight
                  onClick={() => {
                    setTarget("eulaMarketing");
                    setViewMode(true);
                  }}
                />
              </LabelWarp>
            </AgreeWrap>
          </Detail>
        </SlideModal>
      )}
      <Section>
        <Content>
          <IntroduceTextDiv>
            <p>
              고객님 안녕하세요.
              <br />
              모빌리티 통합 포인트 <span>뮤포인트 회원가입</span>을 환영합니다.
              <br />
              이메일 / 패스워드를 통해 손쉽게 가입하세요.
            </p>
          </IntroduceTextDiv>
          <EasySignUpInputDiv>
            <div>
              <h3>이메일 아이디</h3>
              <input
                type="email"
                placeholder="이메일을 입력하세요."
                name="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <SettingPwInfo>
                <p>이메일 아이디는 뮤포인트 로그인 아이디로 사용됩니다.</p>
                {!checkedEmail && email != "" && (
                  <p className="pink">이메일 형식이 올바르지 않습니다.</p>
                )}
              </SettingPwInfo>
            </div>
            <div>
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호를 입력하세요."
                name="password"
                value={passwords.password}
                onChange={(e) => {
                  setPasswords((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
              <SettingPwInfo>
                <p>
                  8~20자 영문 대소문자, 숫자, 특수문자 혼합,
                  <br /> 대소문자 구별 (예시 : Abc123!@#)
                  <br /> *사용가능 특수문자 : ~, !, @, #, $, %, ^, &, *, ?,
                  &#40;, &#41;
                </p>
                {!checkedPw && passwords.password != "" && (
                  <p className="pink">사용할 수 없는 비밀번호입니다.</p>
                )}
                {checkedPw && (
                  <p className="col">사용 가능한 비밀번호입니다.</p>
                )}
              </SettingPwInfo>
            </div>
            <div>
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호를 한번 더 입력 부탁드립니다."
                name="confirmPassword"
                value={passwords.confirmPassword}
                onChange={(e) => {
                  setPasswords((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
              <SettingPwInfo>
                {checkedConfirmPw && (
                  <p className="col">비밀번호가 일치합니다.</p>
                )}
              </SettingPwInfo>
            </div>
          </EasySignUpInputDiv>
        </Content>
        <Btns>
          <ButtonL
            disabled={!(checkedPw && checkedConfirmPw && checkedEmail)}
            onClick={() => {
              setOpenPopUp(true);
            }}
          >
            다음
          </ButtonL>
        </Btns>
      </Section>
    </OnlyTitleHeaderLayout>
  );
};

export default EasySignUp;
const IntroduceTextDiv = styled(TextDiv)`
  p {
    letter-spacing: -0.42px;
    span {
      font-family: NanumSquareB;
    }
  }
`;
const EasySignUpInputDiv = styled(InputsDiv)`
  margin-top: 5rem;
  padding-bottom: 5rem;
`;
const SettingPwInfo = styled(TextDiv)`
  text-align: left;
  p {
    margin-top: 1rem;
  }
`;
const AllAgreeWrap = styled.div`
  padding: 1rem 0 2rem 0;
  border-bottom: 1px solid #000;
`;

const AgreeWrap = styled.ul`
  /* margin-top: 1rem; */
`;

const LabelWarp = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  label {
    font-size: 1.4rem;
    line-height: 1.4rem;
    span {
      margin-left: 0.5rem;
    }
  }
  .col {
    color: ${({ theme }) => theme.color.yellow};
  }
`;

const Detail = styled.div`
  padding: 3rem 0;
`;
